import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Box,
  Button as Btn,
  DialogActions,
  Divider,
  Grid,
  MenuItem,
} from '@mui/material';

import {
  Button,
  ChunkedFileUploader,
  Select,
  Typography
} from '../../../../components/v2/styled';
import { Base } from '../Base';

import { KnowledgeAttachment } from '../../../../models/KnowledgeAttachment';

import HelpersLanguage from '../../../../actions/helpers/language';

// const { DateTime } = require("luxon");

type Props = {
  currentAttachment: KnowledgeAttachment;
  refetchSubjects: () => void;
  open: boolean;
  setOpen: (b:boolean) => void;
};

export const KnowledgeAddAttachment: FunctionComponent<Props> = ({refetchSubjects, currentAttachment, open, setOpen}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [mainObject, setMainObject] = useState<KnowledgeAttachment>(currentAttachment);
  const [isUploading, setIsUploading] = useState<boolean>();
  const [flickerChunker, setFlickerChunker] = useState<boolean>(true);









  const mutationDelete = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<KnowledgeAttachment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      refetchSubjects();
      setMainObject({});
      setOpen(false);
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      reopen: boolean;
    }) => {
      return fetch_one<KnowledgeAttachment>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      refetchSubjects();
      if (!!variables.reopen) {
        setMainObject({
          ...mainObject,
          item_link: '',
          id: undefined
        });
        setFlickerChunker(false);
      }
      if (!variables.reopen) {
        setMainObject({});
        setOpen(false);
      }
    },
  });




  










  const saveObject = (reopen:boolean) => {
    let data = new FormData();
    data.append('object', 'knowledge_attachment');
    data.append('handler_id', login?.id?.toString() || '');
    data.append('practice_id', (login?.practice_id || currentPractice?.id || '').toString() || '');
    if (!!mainObject?.id) data.append('id', mainObject?.id?.toString() || '');
    if (!!mainObject?.id) data.append('ob[id]', mainObject?.id?.toString() || '');
    if (!!mainObject?.knowledge_course_id) data.append('ob[knowledge_course_id]', mainObject?.knowledge_course_id?.toString() || '');
    if (!!mainObject?.knowledge_lesson_id) data.append('ob[knowledge_lesson_id]', mainObject?.knowledge_lesson_id?.toString() || '');
    data.append('ob[is_featured]', !!mainObject?.is_featured ? '1' : '0');
    data.append('ob[locale]', mainObject?.locale?.toString() || 'nl');
    data.append('ob[item_link]', mainObject?.item_link?.toString() || '');
    
    // if (!!mainObject.item) {
    //   data.append(`ob[item]`, mainObject.item);
    // }
    
    mutationSave.mutate({
      formData: data,
      reopen: reopen
    });
  };


  useEffect(() => {
    if(!!currentAttachment) setMainObject(currentAttachment);
  }, [currentAttachment]);
  useEffect(() => {
    if(!flickerChunker) {
      setTimeout(() => {
        setFlickerChunker(true);
      }, 200);
    }
  }, [flickerChunker]);

  return (<>
    <Base
      name="add_attachment"
      title={t("coach.knowledge_attachments.dialogs.add_edit")}
      maxWidth='xl'
      onClose={() => {
        setMainObject({});
      }}
      content={<>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{
              borderRadius: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.warning.main,
              padding: 1,
              textAlign: 'center'
            }}>
              {!currentAttachment?.knowledge_lesson_id && <Typography html>{t("coach.submenu.knowledge_attachment.linked_to_course", {course: currentAttachment.knowledge_course?.name})}</Typography>}
              {!!currentAttachment?.knowledge_lesson_id && !!mainObject.is_featured && <Typography html>{t("coach.submenu.knowledge_attachment.linked_to_lesson", {course: currentAttachment.knowledge_course?.name, lesson: currentAttachment.knowledge_lesson?.name})}</Typography>}
              {!!currentAttachment?.knowledge_lesson_id && !mainObject.is_featured && <Typography html>{t("coach.submenu.knowledge_attachment.linked_to_lesson_as_attachment", {course: currentAttachment.knowledge_course?.name, lesson: currentAttachment.knowledge_lesson?.name})}</Typography>}
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <Box sx={{
              borderRadius: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.warning.main,
              padding: 1,
              textAlign: 'center'
            }}>
              <Typography html>{t("coach.submenu.knowledge_attachment.linked_to_course")}</Typography>
              <Typography html sx={{fontWeight: 'bold'}}>{currentAttachment.knowledge_course?.name}</Typography>
            </Box>
          </Grid> */}
          {/* {!!currentAttachment.knowledge_lesson && <Grid item xs={12}>
            <Box sx={{
              borderRadius: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.warning.main,
              padding: 1,
              textAlign: 'center'
            }}>
              <Typography html>{t("coach.submenu.knowledge_attachment.linked_to_lesson")}</Typography>
              <Typography html sx={{fontWeight: 'bold'}}>{currentAttachment.knowledge_lesson?.name}</Typography>
            </Box>
          </Grid>} */}

          <Grid item xs={12} sx={{marginTop: 2}}>
            <Typography variant="h5">{t("coach.submenu.attachment_sections.options")}</Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} md={4}>
            <Select
              fullWidth
              displayEmpty
              caption={t("coach.models.knowledge_attachments.locale")}
              id="locale"
              value={mainObject.locale || 'nl'}
              setValue={(v) => {
                setMainObject({
                  ...mainObject,
                  locale: !!v ? v?.toString() : undefined
                });
              }}
            >
              {HelpersLanguage.available_locales().map(locale => <MenuItem value={locale}>{locale.toUpperCase()}</MenuItem>)}
            </Select>
          </Grid>
          {!!currentAttachment.get_item && <Grid item xs={12} md={8}>
            <video id="video" controls style={{objectFit: 'contain', width: '100%'}}>
              <source src={currentAttachment.get_item} type="video/mp4"/>
            </video>
          </Grid>}
          {/* <Grid item xs={12} md={4}>
            <Switcher
              id="is_featured"
              caption={t("coach.models.knowledge_attachments.is_featured")}
              disabled={!currentAttachment?.knowledge_lesson_id}
              value={!!mainObject?.is_featured || !currentAttachment?.knowledge_lesson_id}
              onChange={(c) => {
                setMainObject({
                  ...mainObject,
                  is_featured: c
                });
              }}
            />
          </Grid> */}

          <Grid item xs={12} sx={{marginTop: 4}}>
            <Typography variant="h5">{t("coach.submenu.attachment_sections.attachment")}</Typography>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            {!!flickerChunker && <ChunkedFileUploader
              caption={''}
              fileInputName="attachment_uploader"
              accept={!!mainObject.is_featured ? 'video/*' : ''}
              current={!!currentAttachment.item_link ? `${currentAttachment.item_link}?filename=${currentAttachment.item_file_name}` : currentAttachment.item_file_name}
              onChange={(url) => {
                setMainObject({
                  ...mainObject,
                  item_link: url
                });
              }}
              onChangeIsUploading={(b) => {
                setIsUploading(b);
              }}
            />}
            {/* <span>{currentAttachment.item_link}?filename={currentAttachment.item_file_name}</span> */}
          </Grid>
          {/* {!mainObject.hide_current && <>
            {!currentAttachment.knowledge_lesson && !!((currentAttachment.knowledge_course?.videos || {})[mainObject.locale || 'nl']).item_file_name && <Grid item xs={12}>
              <Typography sx={{color: theme.palette.primary.main}}>{t("general.terms.current_file")}: {((currentAttachment.knowledge_course?.videos || {})[mainObject.locale || 'nl'] || {}).item_file_name}</Typography>
            </Grid>}
            {!!currentAttachment.knowledge_lesson && !!((currentAttachment.knowledge_lesson?.videos || {})[mainObject.locale || 'nl'] || {}).item_file_name && <Grid item xs={12}>
              <Typography sx={{color: theme.palette.primary.main}}>{t("general.terms.current_file")}: {((currentAttachment.knowledge_lesson?.videos || {})[mainObject.locale || 'nl'] || {}).item_file_name}</Typography>
            </Grid>}
          </>}
          <Grid item xs={12}>
            <Typography sx={{fontSize: '0.8rem'}}>{t("general.knowledge_courses.fields.video")}</Typography>
            <ImagePicker
              existing={mainObject?.get_item}
              deleteable
              video
              backend
              item={item}
              itemUrl={itemUrl}
              onSelect={(_item:File|undefined, _itemUrl:string|undefined) => {
                setItem(_item);
                setItemUrl(_itemUrl);
                setMainObject({
                  ...mainObject,
                  item: _item,
                  itemUrl: _itemUrl
                });
                if (!_item && !_itemUrl) {
                  setItemCleared(true);
                } else {
                  setItemCleared(false);
                }
              }}
            />
          </Grid> */}

        </Grid>
      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        {!!mainObject.id && <Button
          id="destroy_btn"
          destroyBtn
          disabled={mutationSave.isPending || !!isUploading || !mainObject.id}
          onClick={(e) => {
            mutationDelete.mutate({formData: {
              object: 'knowledge_attachment',
              id: mainObject.id,
              ob: {
                id: mainObject.id,
              }
            }});
          }}
          secondary
          text
          label={t("coach.general.actions.destroy")}
          sx={{
            marginRight: 'auto',
            marginTop: 0
          }}
        />}
        <Btn
          disabled={mutationSave.isPending}
          onClick={(e) => {
            setMainObject({});
            setOpen(false);
          }}
          color="primary"
        >{t("coach.general.actions.cancel")}</Btn>
        <Btn
          disabled={mutationSave.isPending || !!isUploading || !mainObject.item_link}
          onClick={(e) => {
            saveObject(false);
          }}
          color="primary"
        >{t("client.general.actions.save")}</Btn>
        {!mainObject?.is_featured && <Btn
          disabled={mutationSave.isPending || !!isUploading || !mainObject.item_link}
          onClick={(e) => {
            saveObject(true);
          }}
          color="primary"
        >{t("coach.general.actions.save_and_add")}</Btn>}
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}
